import React from "react";
import UserIcon from "../../../assets/Images/user1.png";
import NameIcon from "../../../assets/Images/name-icon.png";
import AddressIcon from "../../../assets/Images/address-icon.png";
import DateIcon from "../../../assets/Images/date.png";
import PhoneIcon from "../../../assets/Images/phone.png";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import FiberPinIcon from "@mui/icons-material/FiberPin";

import { FieldSchema } from "../components/GenericForm";

/** Helper to render image icons */
const renderIcon = (src: string, alt: string): React.ReactNode => (
  <img src={src} alt={alt} className="imgs" style={{ width: 24, height: 24 }} />
);

/** Signup Form Schema */
export const signupFormSchema: FieldSchema[] = [
  {
    type: "text",
    name: "user_name",
    label: "Username",
    icon: renderIcon(UserIcon, "Username"),
    required: true,
    placeholder: "Enter your username",
  },
  {
    type: "text",
    name: "name",
    label: "Name",
    icon: renderIcon(NameIcon, "Name"),
    placeholder: "Enter your name",
  },
  {
    type: "text",
    name: "organization_name",
    label: "Organization name",
    icon: renderIcon(AddressIcon, "Organization name"),
    required: true,
    placeholder: "Enter organization name",
  },
  {
    type: "text",
    name: "org_Arabic_Name",
    label: "Organization arabic name",
    icon: renderIcon(AddressIcon, "Org arabic name"),
    placeholder: "Enter org arabic name",
  },
  {
    type: "businessType",
    name: "business_type",
    label: "Business type",
    placeholder: "Select business type",
  },
  {
    type: "email",
    name: "email_id",
    label: "Email",
    icon: <MailOutlineIcon />,
    required: true,
    placeholder: "Enter your email",
  },
  {
    type: "email",
    name: "secondary_email_id",
    label: "Alternative email",
    icon: <MailOutlineIcon />,
    placeholder: "Enter alternative email",
  },
  {
    type: "date",
    name: "date_of_birth",
    label: "Date of Birth (DD-MM-YYYY)",
    icon: renderIcon(DateIcon, "Date"),
    grid: { xs: 12, sm: 6 },
    placeholder: "DD-MM-YYYY",
  },
  {
    type: "tel",
    name: "phone_number",
    label: "Phone number",
    icon: renderIcon(PhoneIcon, "Phone"),
    grid: { xs: 12, sm: 6 },
    required: true,
    placeholder: "Enter phone number",
  },
  {
    type: "tel",
    name: "secondary_phone_number",
    label: "Alternative phone number",
    icon: renderIcon(PhoneIcon, "Phone"),
    grid: { xs: 12, sm: 6 },
    placeholder: "Enter alternative phone number",
  },
  {
    type: "text",
    name: "address_line_1",
    label: "Address",
    icon: renderIcon(AddressIcon, "Address"),
    placeholder: "Enter address",
  },
  {
    type: "text",
    name: "business_location",
    label: "Business location",
    icon: renderIcon(AddressIcon, "Business Location"),
    placeholder: "Enter business location",
  },
  {
    type: "countryState",
    name: "country_state",
    label: "Country/State",
    placeholder: "Select country/state",
  },
  {
    type: "timeZone",
    name: "time_zone_id",
    label: "Time zone",
    placeholder: "Select time zone",
  },
  {
    type: "number",
    name: "postal_code",
    label: "Postal code",
    icon: <FiberPinIcon />,
    placeholder: "Enter postal code",
  },
];
